import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

/**
 * GET /staff/all — supports ?roleId= and ?active=true|false
 * (Staff model uses `active`, not isActive)
 */
export const getAllStaff = async (filters = {}) => {
  const res = await axiosInstance.get(`/staff/all${qs(filters)}`);
  return res.data;
};

export const getStaffById = async (id) => {
  const res = await axiosInstance.get(`/staff/${id}`);
  return res.data;
};
